import "core-js/modules/es6.array.find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import draggable from "vuedraggable";
export default {
  name: "tinfoLinkC",
  components: {
    draggable: draggable
  },
  props: ["childModules", "homeModules"],
  data: function data() {
    return {};
  },
  created: function created() {},
  computed: {},
  methods: {
    addClick: function addClick(data) {
      this.$emit("addClick", data);
    },
    ifSelected: function ifSelected(val) {
      var linkModule = this.homeModules.find(function (item) {
        return item.cardType === "LINK";
      });

      if (linkModule) {
        if (linkModule.cardModules[0].data) {
          return linkModule.cardModules[0].data.some(function (item) {
            return item.navId === val.navId;
          });
        }

        return false;
      }

      return false;
    }
  },
  watch: {},
  filters: {}
};